import axios from "axios";
import { AI_API_TOKEN, AI_API_URL } from "../config/secrets";

/**
 * Request Wrapper with default success/error actions and timeout configuration
 */
const request = async (options) => {
  const client = axios.create({
    baseURL: AI_API_URL,
    headers: {
      Authorization: `${AI_API_TOKEN}`,
    },
    // Set timeout to 5 minutes (300000ms) - adjust as needed
    timeout: 300000, // 5 minutes
    // Alternative: You can also set different timeouts
    // timeout: 180000, // 3 minutes
    // timeout: 600000, // 10 minutes
  });

  const onSuccess = (response) => response?.data;

  const onError = (error) => {
    // console.debug('Request Failed:', error.config);
    if (error.response) {
      // Request was made but server responded with something
      // other than 2xx
      // console.debug('Status:', error.response.status);
      // console.debug('Data:', error.response.data);
    } else if (error.code === "ECONNABORTED") {
      // Handle timeout specifically
      console.error("Request timeout:", error.message);
      return Promise.reject({
        message:
          "Request timeout - AI processing is taking longer than expected",
        code: "TIMEOUT",
      });
    } else {
      // Something else happened while setting up the request
      // triggered the error
      // console.debug('Error Message:', error.message);
    }
    return Promise.reject(error.response ? error.response.data : error);
  };

  return client(options).then(onSuccess).catch(onError);
};

export default request;
